export function ImgResultIcon({ size = 14 }: { size?: number }) {
  return (
    <svg className="compact-log-icon" width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 8L7.5 9.5L10.5 6.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.3"/>
    </svg>
  );
}
